import * as bootstrap from "bootstrap";

const SPN_TABLE_NAV_SELECTOR = "[data-spn-table-scrollspy]";

export function initSpnTableScrollSpy(root = document) {
  const nav = root instanceof Element && root.matches(SPN_TABLE_NAV_SELECTOR)
    ? root
    : root.querySelector?.(SPN_TABLE_NAV_SELECTOR);

  if (!(nav instanceof HTMLElement) || nav.id === "") {
    return null;
  }

  const scrollElement = document.body;
  const target = `#${nav.id}`;

  scrollElement.setAttribute("data-bs-spy", "scroll");
  scrollElement.setAttribute("data-bs-target", target);
  scrollElement.setAttribute("data-bs-smooth-scroll", "true");

  const scrollSpy = bootstrap.ScrollSpy.getOrCreateInstance(scrollElement, {
    target,
    rootMargin: "0px 0px -35%",
    smoothScroll: true,
  });

  window.requestAnimationFrame(() => scrollSpy.refresh());

  return scrollSpy;
}